import React from "react";
// import JSONPretty from "react-json-pretty";
import { connect } from "react-redux";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Input } from "@revvsales/components";
import { RevvForm, ErrorMessages } from "../../../../commonComponents";

import {
  CustomFieldInitialValuesMap,
  CustomFieldComponentRules,
  CustomFieldComponentMessages,
} from "./CustomFieldRulesMap";

// Actions Imports
import { DocumentTemplateActions } from "../../../../actions";

const {
  toggleDynamicFieldView,
  setMetaFieldValues,
  setFlagForDefault,
  metaValidStatus,
} = DocumentTemplateActions;

class EmailField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDefaultValue: this._getShowDefaultValue(props),
      emailFieldValues: this._getDataForPrepopulate(props),
    };
  }

  _getShowDefaultValue = propsData => {
    let returnData = false;
    if (propsData.meta && propsData.meta.default) {
      returnData = true;
    }
    return returnData;
  };

  _getDataForPrepopulate = propsData => {
    let returnData = JSON.parse(
      JSON.stringify(CustomFieldInitialValuesMap.EMAIL),
    );
    if (propsData.meta && propsData.meta.default) {
      returnData = propsData.meta;
    }
    return returnData;
  };

  _toggleDefaultValue = () => {
    const { showDefaultValue } = this.state;
    this.setState({ showDefaultValue: !showDefaultValue });
    this.props.setFlagForDefault(!showDefaultValue);
  };

  render() {
    const { showDefaultValue, emailFieldValues } = this.state;
    console.debug("Common field values");
    console.debug(emailFieldValues);
    return (
      <React.Fragment>
        <Input
          id="checkbox"
          type="checkbox"
          data-test="EmailField-checkbox"
          checked={showDefaultValue}
          onChange={() => this._toggleDefaultValue()}
          className="dynamicfieldcustom-footer-input errorborder"
        />
        <span className="dynamicfieldcustom-footer-checkboxinput">
          This has a default value
        </span>
        {showDefaultValue && (
          <RevvForm
            initialFormValue={emailFieldValues}
            customFieldName="EMAIL"
            customFieldComponentRules={CustomFieldComponentRules}
            customFieldComponentMessages={CustomFieldComponentMessages}
            render={formProps => {
              const {
                handleChange,
                handleBlur,
                messages,
                touched,
                errors,
                values,
                isValid,
              } = formProps;
              const allInAll = {
                isValid,
                messages,
                touched,
                errors,
                values,
              };
              console.debug("allInAll", allInAll);
              if (isValid) {
                this.props.metaValidStatus(true);
                this.props.setMetaFieldValues(values);
              } else {
                this.props.metaValidStatus(false);
                this.props.setMetaFieldValues({});
              }
              return (
                <React.Fragment>
                  <div className="dynamicfieldcustom-revvform">
                    <span className="revvform-label">
                      Default value
                      <span className="requiredwitherr-input"> *</span>
                    </span>
                    <Input
                      autoFocus
                      id="default"
                      name="default"
                      data-test="EmailField-default"
                      value={values && values.default}
                      className={`dynamicfieldcustom-footer-input errorborder ${
                        messages.default !== undefined &&
                        messages.default.required !== ""
                          ? "danger-border"
                          : ""
                      }`}
                      placeholder="Enter field default value"
                      onChange={value => handleChange(value)}
                      onBlur={value => handleBlur(value)}
                      required
                    />
                    {messages.default && (
                      <ErrorMessages
                        messages={
                          messages.default.required ||
                          messages.default.validateEmail
                        }
                      />
                    )}
                  </div>
                </React.Fragment>
              );
            }}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  const {
    meta,
  } = state.TemplateStore.dynamicFields.selectedDynamicFieldForUpdate;
  return {
    meta,
  };
};

const mapDispatchToProps = {
  toggleDynamicFieldView,
  setFlagForDefault,
  metaValidStatus,
  setMetaFieldValues,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EmailField);



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldComponents/EmailField.js